import {
	ADMINDELETEINTEGRATION_SUCCESS,
	ADMINDELETEINTEGRATION_FAILED,
	RESET_ADMINDELETEINTEGRATION,
	LOADING_ADMINDELETEINTEGRATION,
	NETWORK_ERROR_ADMINDELETEINTEGRATION
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {},
	message: "",
	networkError: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINDELETEINTEGRATION:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {},
				message: "",
				networkError: ""
			};
		case ADMINDELETEINTEGRATION_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case ADMINDELETEINTEGRATION_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload,
				message: "",
				networkError: ""
			};
		case NETWORK_ERROR_ADMINDELETEINTEGRATION:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {},
				message: "",
				networkError: ""
			};
		case RESET_ADMINDELETEINTEGRATION:
			return (state = initialState);
		default:
			return state;
	}
};
